// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarMenu_navbar__tCA42 {
    height: rem(700px);
    width: 250px;
    padding: var(--mantine-spacing-md);
    display: flex;
    flex-direction: column;
    color: var(--mantine-color-text-0);
    background-color: var(--mantine-color-blue-5);
    border-right: rem(1px) solid
        light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
}

.SidebarMenu_navbarMain__Dp0Cq {
    flex: 1 1;
}

.SidebarMenu_header__g4j8Z {
    padding-bottom: var(--mantine-spacing-md);
    margin-bottom: calc(var(--mantine-spacing-md) * 1.5);
    border-bottom: rem(10px) solid var(--mantine-color-gray-0);
}

.SidebarMenu_footer__4kqnK {
    padding-top: var(--mantine-spacing-md);
    margin-top: var(--mantine-spacing-md);
    border-top: rem(1px) solid rem(10px) solid var(--mantine-color-gray-0);
}

.SidebarMenu_link__vr5-5 {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-text-0);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    border-radius: var(--mantine-radius-sm);
    font-weight: 500;

    @mixin hover {
        background-color: var(--mantine-color-fuchasia-2);
        color: var(--mantine-color-text-0);
        .SidebarMenu_linkIcon__xRRer {
            color: var(--mantine-color-white);
        }
    }

    &[data-active] {
        &,
        &:hover {
            background-color: var(--mantine-color-fuchasia-4);
            color: var(--mantine-color-text-0);
            .SidebarMenu_linkIcon__xRRer {
                color: var(--mantine-color-text-0);
            }
        }
    }
}

.SidebarMenu_linkIcon__xRRer {
    color: var(--mantine-color-text-0);
    margin-right: var(--mantine-spacing-sm);
    width: rem(25px);
    height: rem(25px);
}
`, "",{"version":3,"sources":["webpack://./src/components/style/SidebarMenu.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,6CAA6C;IAC7C;4EACwE;AAC5E;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,yCAAyC;IACzC,oDAAoD;IACpD,0DAA0D;AAC9D;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,sEAAsE;AAC1E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,sCAAsC;IACtC,kCAAkC;IAClC,4DAA4D;IAC5D,uCAAuC;IACvC,gBAAgB;;IAEhB;QACI,iDAAiD;QACjD,kCAAkC;QAClC;YACI,iCAAiC;QACrC;IACJ;;IAEA;QACI;;YAEI,iDAAiD;YACjD,kCAAkC;YAClC;gBACI,kCAAkC;YACtC;QACJ;IACJ;AACJ;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".navbar {\r\n    height: rem(700px);\r\n    width: 250px;\r\n    padding: var(--mantine-spacing-md);\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: var(--mantine-color-text-0);\r\n    background-color: var(--mantine-color-blue-5);\r\n    border-right: rem(1px) solid\r\n        light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));\r\n}\r\n\r\n.navbarMain {\r\n    flex: 1;\r\n}\r\n\r\n.header {\r\n    padding-bottom: var(--mantine-spacing-md);\r\n    margin-bottom: calc(var(--mantine-spacing-md) * 1.5);\r\n    border-bottom: rem(10px) solid var(--mantine-color-gray-0);\r\n}\r\n\r\n.footer {\r\n    padding-top: var(--mantine-spacing-md);\r\n    margin-top: var(--mantine-spacing-md);\r\n    border-top: rem(1px) solid rem(10px) solid var(--mantine-color-gray-0);\r\n}\r\n\r\n.link {\r\n    display: flex;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    font-size: var(--mantine-font-size-sm);\r\n    color: var(--mantine-color-text-0);\r\n    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\r\n    border-radius: var(--mantine-radius-sm);\r\n    font-weight: 500;\r\n\r\n    @mixin hover {\r\n        background-color: var(--mantine-color-fuchasia-2);\r\n        color: var(--mantine-color-text-0);\r\n        .linkIcon {\r\n            color: var(--mantine-color-white);\r\n        }\r\n    }\r\n\r\n    &[data-active] {\r\n        &,\r\n        &:hover {\r\n            background-color: var(--mantine-color-fuchasia-4);\r\n            color: var(--mantine-color-text-0);\r\n            .linkIcon {\r\n                color: var(--mantine-color-text-0);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.linkIcon {\r\n    color: var(--mantine-color-text-0);\r\n    margin-right: var(--mantine-spacing-sm);\r\n    width: rem(25px);\r\n    height: rem(25px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `SidebarMenu_navbar__tCA42`,
	"navbarMain": `SidebarMenu_navbarMain__Dp0Cq`,
	"header": `SidebarMenu_header__g4j8Z`,
	"footer": `SidebarMenu_footer__4kqnK`,
	"link": `SidebarMenu_link__vr5-5`,
	"linkIcon": `SidebarMenu_linkIcon__xRRer`
};
export default ___CSS_LOADER_EXPORT___;
